import { render } from "./HausarztProgramm.vue?vue&type=template&id=c6c9d0f2&scoped=true"
import script from "./HausarztProgramm.vue?vue&type=script&lang=js"
export * from "./HausarztProgramm.vue?vue&type=script&lang=js"

import "./HausarztProgramm.vue?vue&type=style&index=0&id=c6c9d0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c9d0f2"]])

export default __exports__